import type { ReactNode } from 'react';
import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

interface AnimatedPageProps {
  children: ReactNode;
}

const AnimatedPage: React.FC<AnimatedPageProps> = ({ children }) => {
  const reducedMotion = useReducedMotion() ?? false;
  return (
    <motion.div
      initial={reducedMotion ? false : { opacity: 0, y: 8 }}
      animate={reducedMotion ? undefined : { opacity: 1, y: 0 }}
      exit={reducedMotion ? undefined : { opacity: 0, y: -8 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      style={{ minHeight: '100%' }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedPage;
